<template>
  <aicc-page :pageId="this.contextPageId">
      <ur-area>
        <div class="monitoring-box">
              <div class="campaign">
                <p>
                {{$t("MSG_TXT_ING_CAMPAIGN")}}
                </p>
                <div class="campaign_box">
                   <!-- <ur-dropdown  v-model="campaignValue"  :items="campaignItems" style="width: 440px;" :searchable="true"/>   -->
                   <autoMultiDropdown v-model="campaignValue"  selectAll :items="campaignItems" :itemsSize="240" placeholder="전체" selectedAllText="전체"/>   
                </div>
              </div>
              
            
            <div class="info">
              <div class="timer">
                <div class="select_box" style="width:160px">                        
                  <ur-dropdown v-model="refreshTimeValue" :items="refreshTimeItems" />
                </div>
                <ur-button class="btn_refresh" @click="onClickSearch" ></ur-button>
              </div>

              <p class="info_txt">{{datetit}}  {{day}}요일 <span>{{time}} 기준</span><br>
              <span  class="total_cnt_strong">총 {{todayTotalCnt}}</span>건의 통화가 진행중입니다.</p>
              <ul class="state">
                <li>통화중<span class="ing">{{todayIngCnt}}</span></li>
                <li>통화종료<span class="end">{{todayCompCnt}}</span></li>
              </ul>
            </div>
         </div>  

    
      <ur-data-grid ref="gridScenario" :headers="headers" :data-source="tableItems" :options="tableOptions" style="width:100%; height:100%">          
      <template #header>
        <ur-data-grid-header-row>
            <ur-data-grid-header-cell/>
            <ur-data-grid-header-cell/>
            <ur-data-grid-header-cell/>
            <ur-data-grid-header-cell/>
            <ur-data-grid-header-cell/>
            <ur-data-grid-header-cell/>
            <ur-data-grid-header-cell/>
            <ur-data-grid-header-cell>
              {{headers[7].text}} <ur-icon type="line" id="home" class="icon-tooltip">information</ur-icon>
              <ur-tooltip target-id="home" bottom mouse-over>
                <div class="tooltip multi">
                  <ul class="progress_bar_state">
                    <li class="p1">질문의도 충족</li>
                    <li class="p2">반복 후 의도충족</li>
                    <li class="p3">질문의도 미충족 </li>
                    <li class="p4">미응답</li>
                  </ul>
                </div>
              </ur-tooltip>
            </ur-data-grid-header-cell>
        </ur-data-grid-header-row>
      </template>
      </ur-data-grid>
      <aicc-recording-modal ref="recordModal" :convDataset="modalDataset" @closed="closedRecModal"/>
      <aicc-conversation-modal ref="convModal" :convDataset="modalDataset"/>
    </ur-area>
  </aicc-page>
  <!--
  <sui-page>
    <sui-page-contents>
       <ur-page :title="$t('MSG_TIT_OUTCALL_SCHEDULE_RECORD')">
        <ur-area>

          <ur-form-box toggleable column="2" small>
            <ur-form-item no-label >
              <div class="campaign">
                <p>
                진행중인 캠페인
                </p>
                <div class="campaign_box">
                   <ur-dropdown  v-model="campaignValue"  :items="campaignItems" style="width: 440px;" />  
                </div>
              </div>
              
            
            </ur-form-item>
            <ur-form-item no-label >
            <div class="info">
              <div class="timer">
                <div class="select_box" style="width:160px">                        
                  <ur-dropdown v-model="refreshTimeValue" :items="refreshTimeItems" />
                </div>
                <ur-button class="btn_refresh" @click="onClickSearch" ></ur-button>
              </div>

              <p class="info_txt">2021년 8월 25일 월요일 <span><strong>10:23:03</strong> 기준</span><br><strong>총 44</strong>건의 통화가 진행중입니다.</p>
              <ul class="state">
                <li>통화중<span class="ing">12</span></li>
                <li>통화종료<span class="end">32</span></li>
              </ul>
            </div>
            </ur-form-item>
           </ur-form-box>
        </ur-area>
        <ur-data-grid ref="gridScenario" :headers="headers" :data-source="tableItems" :options="tableOptions" style="width:100%; height:100%">          
        </ur-data-grid>
      </ur-page>
    </sui-page-contents>
  </sui-page>
  -->
</template>

<script>
import BasePage from '~cm/components/BasePage';
import urDataGrid from '@uidev/grid/urDataGrid/urDataGrid';
import {urDataSet} from 'uidev-component/index.js';
import customTextField from '../../components/CMP_AIC_00003/CMP_AIC_00003_C01';
import autoMultiDropdown from '../../components/CMP_AIC_00001.vue';
import urAutoDropdown from "../../../../../node_modules/uidev-component/components/element/urDropdown/urAutoDropdown";

export default {
  name: 'PGE_AIC_00014', 
  components: {
    urDataGrid,
    customTextField:customTextField,
    autoMultiDropdown,
  },
  extends: BasePage,
  /* props: {
    selectedCampaignId:{
        type: String,
        default: null,
    },
  }, */
  data() {
    return {
      tableItems: new urDataSet(),
      tableOptions: {
        infinityScroll: true,
        timezone: +9,
        height:0,
        msgTotal: "총 #",
        msgAscending   : '오름차순 정렬',
        msgDescending  : '내림차순 정렬', 
        msgEmptyData: '현재 진행중인 통화가 없습니다.',
      },
      queryData: {
        campaignId: '',
        scenarioType: '',
        calltxType: '',
        calleeNumber: '',
      },
      homeStatusAsk: {
        tenantId: '',
      },
      headers: [
        { text: this.$i18n.t('MSG_TXT_OUTCALL_RESULT_DATA'),  value: 'itemStatus', sort:true, align:'left',type:'code', width: '136px', freeze:true,
          domain:[{value:'C',text:'통화종료'}, {value:'B',text:'통화중'}],
          component :  { props : ['row','value','text'], // provided by grid
            template :`<span class="c-cell"><ur-badge :color="badgeColor" shape="dot" :text="text"/></span>`,
            computed : {
              badgeColor() {return {'C':'default','B':'processing'}[this.value]||'default';}
              },
          }
        },
        { text: this.$i18n.t('MSG_TXT_CALL_START'), value: 'startTime',align:'center',  width: '100px', dateFormat: 'HH:mm:ss', type: 'date', timezone:+9, freeze:true},
        { text: this.$i18n.t('MSG_TXT_CALL_END'), value: 'endTime', align:'center', width: '100px', dateFormat: 'HH:mm:ss', type: 'date', timezone:+9, freeze:true},
        { text: this.$i18n.t('MSG_TXT_CALLEE_NUMBER1'), value: 'calleeNumber',align:'left', width: '150px', freeze:true},
        { text: this.$i18n.t('MSG_TXT_CALLEE_ID'), value: 'calleeId', width: '88px', freeze: true, sort: true },
        { text: this.$i18n.t('MSG_TXT_TELLER_REQ'), value: 'callTxMark', width: '120px' , align:'center',  freeze:true, type:"code"
                , filter:true,checker: (v,filter)=> {
                  console.log('v', v, 'reservationDate filter', filter)
                  if (Array.isArray(filter)) {
                    if (filter.length === 0) {                      
                      return false;
                    }
                    this.tableOptions.msgEmptyData ="선택하신 조건의 조회결과가 없습니다." 
                    for (let ii = 0; ii < filter.length; ii++) {
                      let filterData = filter[ii];
                      if(filterData==="상담원요청"){
                        if(v==="Y"){
                          return true;
                        }                        
                      }else if(filterData==="상담원미요청"){
                        if(v!=="Y"){
                          return true;
                        }
                      }else{
                        console.log(this.tableOptions.msgEmptyData )
                        
                        return false;
                      } 
                    }
                  }
                  
                },
                domain : ['상담원미요청','상담원요청']
                ,customClass : function(v, r) {
                    if(v === 'Y') return 'check';
                    return 'nonCheck'
          }
        },
        { text: this.$i18n.t('MSG_TIT_CONVERSATION'), value: 'itemIndex', align:'center', freeze:true, width: '72px',
          component: {
            props: ['row', 'value', 'text'],
            template :
            '<span>\
              <span v-if="onCheckRecordExist(row)">\
                <button type="button" class="btn btn_play" @click="onClickRecModal(row)">듣기</button>\
              </span><span v-else>\
                <button type="button" class="btn btn_play" disabled @click="onClickRecModal(row)">듣기</button>\
              </span>\
              <button type="button" class="btn btn_stt" @click="onClickConvModal(row)">보기</button>\
            </span>\
             ',
            methods: {
              onCheckRecordExist(row) {
                if(row.recordExistYn === 'Y') return true;
                return false;
              },
              setData(row){
                var component = this.getComponent('PGE_AIC_00014');
                component.modalDataset.itemIndex = row.itemIndex;
                component.modalDataset.scheduleId = row.scheduleId;
                component.modalDataset.scheduleName = row.scheduleName;
                component.modalDataset.conversationTime = row.outcallReqTime;
                component.modalDataset.calleeNumber = row.calleeNumber;
                component.modalDataset.scenarioName = row.scenarioName;
                component.modalDataset.retryTimes = row.retryTimes;
                component.modalDataset.callTxMark = row.callTxMark;
                component.modalDataset.insertReason = row.insertReason;
                component.modalDataset.scenarioStartEnd = row.scenarioStartEnd;
                component.modalDataset.startTime = row.startTime;
                component.modalDataset.endTime = row.endTime;
                component.modalDataset.sessionId = row.sessionId;
                component.modalDataset.itemStatus = row.itemStatus;
              },
              onClickConvModal(row) {
                this.setData(row);
                this.getComponent('PGE_AIC_00014').$refs['convModal'].open()
                },
              onClickRecModal(row) {
                this.setData(row);
                this.getComponent('PGE_AIC_00014').$refs['recordModal'].open()
                },
              getComponent(name) {
                let component = null;
                let thisComponent = this;
                while(thisComponent && !component) {
                  if(thisComponent.$options.name === name) {
                  component = thisComponent;
                  break;
                  }
                  thisComponent = thisComponent.$parent;
                }
                return component;
              },
          }}
        },
        { text: this.$i18n.t('MSG_TXT_SCENARIO_PROGRESS'), value: 'answerList',
          width: "10000px", // 초기값
          customValue: () => { ''; }, // tooltip 생략
          component:{
            props:['row', 'value', 'text'],
            template:'<span><aicc-scenario-progress-bar :items="row.answerSet"/></span>',
            methods: {
              onCheckSuccess(row) {
                if(row.itemStatus === 'C') return true;
                return false;
              },
            }
          },
        },
			],
      scenarioProgressMaxSize: 0,
      scenarioProgressMinSize: 200, // 시나리오 진행 데이터가 없어도 컬럼명 표시를 위한 최소 width
      selected : [],
      campaignListAsk: {
        tenantId: this.$store.getters.userInfo.tenantId,
        sdate: '',
        edate: '',
      },
      sDate: new Date(),
      eDate: moment(this.sDate).add(2, 'days').toDate(),
      //disabledDatesTo: {from: null, to: sDate},
      disabledDates: `${moment(this.sDate).format('YYYY-MM-DD')}~${moment().add(1, 'month').format('YYYY-MM-DD')}`,
      placeholder: this.$t('MSG_TXT_ALL'), 
      objScenarioList: [],
      dataList : [],
      campaignValue:[],
      campaignDropdown : [],
      scenarioColMax : 1,
      refreshTimeValue:'10000',
      timer: '',
      selectedCampaignId:'',
      datetit: this.getDateTit(),
      date: this.getDate(),
      day: this.getDay(),
      time: this.getTime(),
      todayCompCnt: 0,
      todayIngCnt: 0,     
      todayTotalCnt : 0,
      modalDataset: {
        pageid: this.$options.name,
        itemIndex: '',
        scheduleId: '',
        campaignName: '',
        conversationTime: '',
        calleeNumber: '',
        scenarioName: '',
        retryTimes: '',
        callTxMark: '',
        insertReason: '',
        scenarioStartEnd: '',
        startTime: '',
        endTime: '',
        sessionId: '',
        itemStatus: '',
      }
    };
  },
  created() {
   
    
  },
  computed: { 
    
    campaignItems(){            
      return this.campaignDropdown;
    },
    agentRequestItems() {
       let rtn = [];
            rtn.push({value:'s1',text:'전체'});
            rtn.push({value:'s2',text:'Y'});
            rtn.push({value:'s3',text:'N'});
            return rtn;
    },
    refreshTimeItems() {
       let rtn = [];
            rtn.push({value:'10000',text:'10초마다 조회'});
            rtn.push({value:'30000',text:'30초마다 조회'});
            rtn.push({value:'60000',text:'1분마다 조회'});
            return rtn;
    },
  },
  watch: {
    campaignValue:function(){
      this.onClickSearch();
    },
    refreshTimeValue:function(){
      this.onClickSearch();
    }
  },
  mounted() {
    
    this.onLoad();
    this.timer = setInterval(this.onClickSearch, this.refreshTimeValue);  
    this.tableOptions.height = $(".ur-area").css("height").replace("px","")-330;
    window.addEventListener('resize', this.handleResize);
  },
  beforeUpdate() {},
  updated() {
    
    
    clearInterval(this.timer);  
    this.timer = setInterval(this.onClickSearch, this.refreshTimeValue);      
  },
  beforeDestroy() {  
    this.cancelAutoUpdate();  
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    // onLoad() {
    //     console.log(this.$store.getters.userInfo.tenantId);

    //     this.selectedCampaignId = utils.getParameter(this, 'selectedCampaignId');
    //     console.log("selectedCampaignId::::"+this.selectedCampaignId)
    //     this.queryData = utils.getParameter(this, 'queryData');
    //     this.tableOptions.msgEmptyData ='';
    //     this.onCampaignList();
    // },
    onLoad() {
      console.log(this.$store.getters.userInfo.tenantId);

    //   this.selectedCampaignId = utils.getParameter(this, 'selectedCampaignId');
    //   console.log("selectedCampaignId::::"+this.selectedCampaignId)
    //   this.queryData = utils.getParameter(this, 'queryData');
    //   this.tableOptions.msgEmptyData ='';
      this.onCampaignList();
    },
    closedRecModal(){
      console.log("closedRecModal");
      console.log(this.headers);
    },
//     onCampaignList() {      
//       this.onChangeDate1();
//       this.campaignListAsk.status = encodeURI(['C']);
//       http.request(this.contextPageId, 'DTS_AIC_00001', {
//         query: this.campaignListAsk,
//       }).then((response) => {
//         /*
//         var idx = 0;
//         const items = [];
//         utils.forEach(response.data.list, obj => {
//           console.log(obj.scheduleName);
          
//           if(obj.scheduleStatus==="C"){
//             items.push({text: obj.scheduleName, value: obj.scheduleId });
//           }
         
//         });
//         this.campaignDropdown =items;
// */
//         const items = [];
//         utils.forEach(response.data.list, obj => {
//           items.push({text: obj.scheduleName, value: obj.scheduleId });
//         });
//         this.campaignDropdown = items;
//         //홈 등에서 모니터링 페이지로 바로 왔을 때 dropdown 셋팅
//         if(!this.selectedCampaignId&&response.data.list.length>0){
//           this.campaignValue = this.campaignDropdown[0].value;
//         }else{
//           this.campaignValue = this.selectedCampaignId;
//         }
//         /* this.campaignValue = this.campaignDropdown[0].value; */
//       });
//     },
    onCampaignList() {      
        this.onChangeDate1();
        this.campaignListAsk.status = encodeURI(['C']);
        http.request(this.contextPageId, 'DTS_AIC_00001', {
            query: this.campaignListAsk,
        }).then((response) => {
            const items = [];
            utils.forEach(response.data.list, obj => {
            items.push({text: obj.scheduleName, value: obj.scheduleId });
            });
            this.campaignDropdown = items;
            this.campaignValue = items;
        });
        },

    onChangeDate1() {
      const current = new Date();
      const current5 =  new Date();
      this.campaignListAsk.sdate = moment(current).format('YYYYMMDD');
      this.campaignListAsk.edate = moment(current).format('YYYYMMDD');
    },
    /* onAfterSelecting(selectedItem, id) {
      console.log(`[Sample] MultiSelect.onAfterSelecting() : selectedItem = ${
        JSON.stringify(selectedItem)
      }, id = ${id}`);
    }, */
    cancelAutoUpdate() {  
      clearInterval(this.timer);  
    },
    
    changeTimeZoneAndFormat(gmt0String){
        if(gmt0String){
          var gmt0 = new Date(gmt0String);
          var gmt9 = new Date(gmt0.getTime() + (540 * 60 * 1000));
          return utils.toStringByFormat(gmt9, "HH:mm:ss");
        }
        return "";
      },
    // async onClickSearch() {
    //   /* 2021.12.27 : (상품쪽 요구사항)  조회하는 동안에는 NoData 표시 하지 않기*/
    //   this.tableOptions.msgEmptyData ='';
    //   const dataParams = {
    //     campaignId: this.campaignValue,
    //     startDate: moment(this.sDate).format('YYYYMMDD'),
    //   };
    //   if(this.campaignValue.length!==0){
    //     http.request(this.contextPageId, 'DTS_AIC_00020', {
    //       query: dataParams,
    //     }).then((response) => {
    //       if(response.data) {
    //         // 통화결과 flag
    //         // conversation 데이터
    //         console.log(response.data.list);
    //         this.todayIngCnt =0;
    //         this.todayTotalCnt =0;
    //         this.todayCompCnt =0;
    //         this.date= this.getDate();
    //         this.day= this.getDay();
    //         this.time=this.getTime();
    //         utils.forEach(response.data.list, rowobj => {
    //           this.todayTotalCnt = this.todayTotalCnt+1;
    //           this.scenarioColMax = this.scenarioColMax > rowobj.numberOfQuestions ? this.scenarioColMax : rowobj.numberOfQuestions;
    //           if(!rowobj.calleeNumber) {
    //             rowobj.calleeNumber = rowobj.calleeNumber1;
    //           }

    //           // timezone 보정
    //           rowobj.startTime = aiccUtils.conversationDownload.changeTimeZoneAndFormat(rowobj.startTime);
    //           rowobj.endTime = aiccUtils.conversationDownload.changeTimeZoneAndFormat(rowobj.endTime);

    //           // if(rowobj.itemStatus==='B'){
    //           if(rowobj.outCallEndCode===''||rowobj.outCallEndCode===null||rowobj.itemStatus==='B'){
    //             rowobj.itemStatus="B";
    //             this.todayIngCnt = this.todayIngCnt+1;
    //           }else{
    //             this.todayCompCnt = this.todayCompCnt+1;
    //           }

    //         /*  // 대화이력 모달에 넘길 구조 정리
    //           const convDataset ={
    //             pageid: this.$options.name,
    //             itemindex: rowobj.itemIndex,
    //             scheduleid: rowobj.scheduleId,
    //             campaignName: utils.trim(rowobj.scheduleName),
    //             conversationTime: utils.trim(rowobj.scenarioStartTime),
    //             calleeNumber: utils.trim(rowobj.calleeNumber),
    //           };
    //           rowobj["convDataset"] = convDataset;
    //           rowobj["answerSet"] = [];
    //           if(rowobj.answerList.length != 0){
    //             utils.forEach(rowobj.answerList, answerData => {
    //               if(answerData.apiType === "B"){
    //                 var data = JSON.parse(answerData.interimData);
    //                 if(data){
    //                   const convdata = {
    //                     questionTitle: data.questionNumber,
    //                     questionContents: data.question,
    //                     answer: data.answer,
    //                     answerType: data.answerCategory,
    //                   }
    //                   rowobj.answerSet.push(convdata);
    //                 }
    //               }
    //             });
    //           }
    //         }); */
    //         rowobj.outcallReqTime = rowobj.callResult === 'N'? '':aiccUtils.conversationDownload.changeTimeZoneAndFormat(rowobj.outcallReqTime);

    //           // 시나리오 시작/종료 object 생성
    //           const scenarioStartEnd = {
    //             start: (rowobj.scenarioStartTime ? 'Y':'N'),
    //             end : (rowobj.scenarioEndTime ? 'Y':'N'),
    //           }
    //           rowobj.retryTimes = rowobj.callResult === "N"? -1:rowobj.retryTimes+1;
    //           rowobj["scenarioStartEnd"] = scenarioStartEnd;
    //           rowobj["answerSet"] = [];
    //             utils.forEach(rowobj.answerList, answerData => {
    //               if(answerData.apiType === "B"){
    //                 var data = JSON.parse(answerData.interimData);
    //                 if(data){
    //                   const convdata = {
    //                     questionTitle: data.questionNumber,
    //                     questionContents: data.question,
    //                     answer: data.answer,
    //                     answerType: data.answerCategory,
    //                   }
    //                   rowobj.answerSet.push(convdata);
    //                 }
    //               }
    //             });
    //             // numberofQuestions 만큼 빈 answerset을 추가해 회색으로 표시한다.
    //             if(rowobj.answerList.length < rowobj.numberOfQuestions){
    //               for(var idx = 0; idx < (rowobj.numberOfQuestions-rowobj.answerList.length); idx++){
    //                   const convdata = {
    //                     questionTitle: '',
    //                     questionContents: '',
    //                     answer: '',
    //                     answerType: '',
    //                   }
    //                   rowobj.answerSet.push(convdata);
    //               }
    //             }
              
    //           }
    //         );

    //         this.todayIngCnt = utils.numberFormat(this.todayIngCnt);
    //         this.todayTotalCnt = utils.numberFormat(this.todayTotalCnt);
    //         this.todayCompCnt = utils.numberFormat(this.todayCompCnt);

    //         console.log(response.data.list);
    //         this.tableItems.setData(response.data.list);
    //         if(response.data.list.length === 0){
    //           //this.tableOptions.msgEmptyData = this.$i18n.t('MSG_TXT_NO_FILTERED_DATA');
    //           this.tableOptions.msgEmptyData = "현재 진행중인 통화가 없습니다. ";
    //         }
    //       }
    //     })
    //     .catch(error => {
    //       utils.aiccMessageBox('알림', '잠시 후 다시 시도해주세요.', '확인', null);
    //     });
    //   }else{
    //     this.tableOptions.msgEmptyData = "현재 진행중인 통화가 없습니다. ";
    //   }
    // },    
    async onClickSearch() {
        /* 2021.12.27 : (상품쪽 요구사항)  조회하는 동안에는 NoData 표시 하지 않기*/
        this.tableOptions.msgEmptyData ='';
        let dataParams = {
            campaignIdList: [],
            startDate: moment(this.sDate).format('YYYYMMDD'),
        };

        this.campaignValue.forEach(obj => {
            dataParams.campaignIdList.push(obj.value);
        });

        if(this.campaignValue.length!==0){
            http.request(this.contextPageId, 'DTS_AIC_00020', {
            data: dataParams,
            }).then((response) => {
            if(response.data) {
                this.scenarioProgressMaxSize = 0; // 조회시 초기화
                // 통화결과 flag
                // conversation 데이터
                console.log(response.data.list);
                this.todayIngCnt =0;
                this.todayTotalCnt =0;
                this.todayCompCnt =0;
                this.date= this.getDate();
                this.day= this.getDay();
                this.time=this.getTime();
                utils.forEach(response.data.list, rowobj => {
                this.todayTotalCnt = this.todayTotalCnt+1;
                this.scenarioColMax = this.scenarioColMax > rowobj.numberOfQuestions ? this.scenarioColMax : rowobj.numberOfQuestions;
                if(!rowobj.calleeNumber) {
                    rowobj.calleeNumber = rowobj.calleeNumber1;
                }

                // timezone 보정
                rowobj.startTime = aiccUtils.conversationDownload.changeTimeZoneAndFormat(rowobj.startTime);
                rowobj.endTime = aiccUtils.conversationDownload.changeTimeZoneAndFormat(rowobj.endTime);

                // if(rowobj.itemStatus==='B'){
                if(rowobj.outCallEndCode===''||rowobj.outCallEndCode===null||rowobj.itemStatus==='B'){
                    rowobj.itemStatus="B";
                    this.todayIngCnt = this.todayIngCnt+1;
                }else{
                    this.todayCompCnt = this.todayCompCnt+1;
                }

                /*  // 대화이력 모달에 넘길 구조 정리
                const convDataset ={
                    pageid: this.$options.name,
                    itemindex: rowobj.itemIndex,
                    scheduleid: rowobj.scheduleId,
                    campaignName: utils.trim(rowobj.scheduleName),
                    conversationTime: utils.trim(rowobj.scenarioStartTime),
                    calleeNumber: utils.trim(rowobj.calleeNumber),
                };
                rowobj["convDataset"] = convDataset;
                rowobj["answerSet"] = [];
                if(rowobj.answerList.length != 0){
                    utils.forEach(rowobj.answerList, answerData => {
                    if(answerData.apiType === "B"){
                        var data = JSON.parse(answerData.interimData);
                        if(data){
                        const convdata = {
                            questionTitle: data.questionNumber,
                            questionContents: data.question,
                            answer: data.answer,
                            answerType: data.answerCategory,
                        }
                        rowobj.answerSet.push(convdata);
                        }
                    }
                    });
                }
                }); */
                rowobj.outcallReqTime = rowobj.callResult === 'N'? '':aiccUtils.conversationDownload.changeTimeZoneAndFormat(rowobj.outcallReqTime);

                // 시나리오 시작/종료 object 생성
                const scenarioStartEnd = {
                    start: (rowobj.scenarioStartTime ? 'Y':'N'),
                    end : (rowobj.scenarioEndTime ? 'Y':'N'),
                }
                rowobj.retryTimes = rowobj.callResult === "N"? -1:rowobj.retryTimes+1;
                rowobj["scenarioStartEnd"] = scenarioStartEnd;
                rowobj["answerSet"] = [];
                    utils.forEach(rowobj.answerList, answerData => {
                    if (answerData.forScenarioProgress) {
                        var data = JSON.parse(answerData.interimData);
                        if(data){
                        const convdata = {
                            questionTitle: data.questionNumber,
                            questionContents: data.question,
                            answer: data.answer,
                            answerType: data.answerCategory,
                        }
                        rowobj.answerSet.push(convdata);
                        }
                    }
                    });
                    // numberofQuestions 만큼 빈 answerset을 추가해 회색으로 표시한다.
                    if(rowobj.answerList.length < rowobj.numberOfQuestions){
                    for(var idx = 0; idx < (rowobj.numberOfQuestions-rowobj.answerList.length); idx++){
                        const convdata = {
                            questionTitle: '',
                            questionContents: '',
                            answer: '',
                            answerType: '',
                        }
                        rowobj.answerSet.push(convdata);
                    }
                    }

                    // 재시도 콜의 item_index를 캠페인 수신리스트 작성시 최초 채번된 item_index로 보정하고, 정해진 수신ID 포맷으로 변환
                    rowobj.calleeId = aiccUtils.stringUtil.itemIndexToCalleeId(rowobj.itemIndex);

                    // 시나리오 진행 max size 계산
                    this.scenarioProgressMaxSize = Math.max(rowobj.numberOfQuestions, rowobj.answerList.length, this.scenarioProgressMaxSize);
                }
                );

                this.headers[7].width = Math.max((this.scenarioProgressMaxSize * 40), this.scenarioProgressMinSize) + 'px'; // 시나리오 진행 컬럼 width 적용

                this.todayIngCnt = utils.numberFormat(this.todayIngCnt);
                this.todayTotalCnt = utils.numberFormat(this.todayTotalCnt);
                this.todayCompCnt = utils.numberFormat(this.todayCompCnt);

                console.log(response.data.list);
                this.tableItems.setData(response.data.list);
                if(response.data.list.length === 0){
                //this.tableOptions.msgEmptyData = this.$i18n.t('MSG_TXT_NO_FILTERED_DATA');
                this.tableOptions.msgEmptyData = "현재 진행중인 통화가 없습니다. ";
                }
            }
            })
            .catch(error => {
            utils.aiccMessageBox('알림', '잠시 후 다시 시도해주세요.', '확인', null);
            });
        }else{
            this.tableOptions.msgEmptyData = "현재 진행중인 통화가 없습니다. ";
        }
    },   
    getCallResult(flag){
      // code map에서 값 조회해 리턴
      return this.callResultTextMap[flag];
    },
    getCallResultFlag(code){
      // code map에서 값 조회해 리턴
      return this.callResultFlagMap[code];
    },
    
    getColumnItem(row, data){
      var item = row[data];
      switch (data) {
        case 'callResult':
          item = this.getCallResult(item);
          break;
        case 'callTxMark':
          item = item === 'Y'? 'Y' : '-';
          break;
        case 'insertReason':
          item = item === 'B'? 'Y' : '-';
        default:
          item = item||"";
      }
      return item;
    }, 
    handleResize(event) {   
        this.$nextTick(() => {
          this.tableOptions.height = $(".ur-area").css("height").replace("px","")-330;
        });
    },  
    getDateTit() {
      var today= new Date();
      var datetit = today.getFullYear()+'년 '+(today.getMonth()+1)+'월 '+today.getDate()+'일';
      return datetit;
    },
    getDate() {
      var today= new Date();

      var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+(("00"+today.getDate().toString()).slice(-2));
      return date;
    },
    getDay() {
      var today= new Date();
      var week = ['일','월','화','수','목','금','토'];
      var day = week[today.getDay()];
      return day;
    },
    getTime() {
      var today= new Date();
      var hh = today.getHours().toString();
      var mm = today.getMinutes().toString();
      var ss = today.getSeconds().toString();
      
      var time = (hh[1]?hh:"0"+hh[0])+":"+(mm[1]?mm:"0"+mm[0])+":"+(ss[1]?ss:"0"+ss[0]); 
      return time;
    },
  },
};

</script>

<style scoped>
</style>
